function toFixedScore(value) {
  const n = Number(value);
  if (!Number.isFinite(n) || n <= 0) return '--';
  return n.toFixed(1);
}

function scoreOrRange(score, freeTest, range) {
  return freeTest ? (range || '--') : toFixedScore(score);
}

function formatDate(value) {
  if (!value) return '';
  const d = new Date(value);
  if (Number.isNaN(d.getTime())) return '';
  return d.toLocaleDateString('en-IN', { day: 'numeric', month: 'short', year: 'numeric' });
}

function normalizeAttempts(lastAttempts) {
  if (!lastAttempts || typeof lastAttempts !== 'object') return [];
  return Object.keys(lastAttempts)
    .map((attemptId) => ({
      attemptId,
      score: Number(lastAttempts[attemptId]?.o_level ?? 0),
      label: formatDate(lastAttempts[attemptId]?.submit_time),
    }))
    .reverse()
    .filter((item) => Number.isFinite(item.score));
}

export function normalizeProficiency(data) {
  if (!data || typeof data !== 'object') {
    return {
      showScore: false,
      freeTest: false,
      isReportAvailable: false,
      score: {},
      attempts: [],
    };
  }

  const freeTest = !!data.free_test;
  return {
    showScore: data.showScore !== false,
    freeTest,
    isReportAvailable: String(data.detailed_report ?? '').toLowerCase() === 'yes',
    score: {
      overall: scoreOrRange(data.o_level, freeTest, data.o_level_range),
      reading: scoreOrRange(data.r_level, freeTest, data.r_level_range),
      writing: scoreOrRange(data.w_level, freeTest, data.w_level_range),
      listening: scoreOrRange(data.l_level, freeTest, data.l_level_range),
      speaking: scoreOrRange(data.s_level, freeTest, data.s_level_range),
    },
    attempts: normalizeAttempts(data.last_attempts),
  };
}
